import React from 'react';
import { Input } from './ui/input';
import QuestionCard from './QuestionCard';

interface TieBreakerQuestionProps {
  questionId?: string;
  title?: string;
  description: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  points?: number;
  earnedPoints?: number;
  questionMetadata?: {
    dailyDouble?: boolean;
  };
}

export const TieBreakerQuestion: React.FC<TieBreakerQuestionProps> = ({
  questionId,
  title = 'Tiebreaker',
  description,
  value,
  onChange,
  disabled = false,
  points = 0,
  earnedPoints,
  questionMetadata,
}) => {
  const isDailyDouble = questionMetadata?.dailyDouble || false;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;

    // Allow empty string for clearing
    if (input === '') {
      onChange('');
      return;
    }

    // Only allow numeric characters (0-9)
    const numericOnly = input.replace(/[^0-9]/g, '');

    // Limit to 4 characters
    const limitedLength = numericOnly.slice(0, 4);

    // Convert to number and only allow valid numbers
    const numValue = parseInt(limitedLength, 10);
    if (!isNaN(numValue)) {
      onChange(limitedLength);
    }
  };

  return (
    <QuestionCard
      points={points}
      earnedPoints={earnedPoints}
      hidePointsIcon={true}
      isDailyDouble={isDailyDouble}
      className="border-2 border-[#2A2A34] bg-black"
      data-test-id={questionId ? `question-${questionId}` : 'tiebreaker-container'}
      data-test-type="tiebreaker"
    >
      <h3 className="text-text-primary text-lg font-gilroy font-bold mb-4 text-center">{title}</h3>
      <p className="text-text-secondary text-base font-gilroy font-light mb-4 text-center">
        {description}
      </p>
      <div className="flex justify-center">
        <Input
          data-test-id="tiebreaker-input"
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          maxLength={4}
          placeholder="0"
          value={value}
          onChange={handleChange}
          disabled={disabled}
          className="bg-white text-black text-center text-2xl font-gilroy border-0 w-32 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
        />
      </div>
    </QuestionCard>
  );
};

export default TieBreakerQuestion;
